import { Lead } from './Lead';

export type Campaign = {
  id: string;
  name: string;
  scrapeKeywords: string[];
  queryPrompt: string;
  createdAt?: string;
  leads?: Lead[];
  scrapeSource: string;
  isLaunched: boolean;
  launchLimit: number;
};

export enum CampaignType {
  Scraping = 'scraping',
  Personal = 'personal',
}
